import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('click', async (e) => {
  const boton = e.target.closest('[data-persa-upsell]');
  if (!boton) return;
  e.preventDefault();
  const id = Number(boton.getAttribute('data-persa-upsell'));
  const secciones = Array.from(document.querySelectorAll('cart-items-component'))
    .map((c) => c.dataset.sectionId)
    .filter(Boolean);
  boton.disabled = true;
  boton.textContent = 'Sumando…';
  const diferido = CartLinesUpdateEvent.createPromise();
  boton.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: String(id), quantity: 1 }],
      promise: diferido.promise,
    })
  );
  try {
    const raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const r = await fetch(raiz + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: secciones.join(',') }),
    });
    const datos = await r.json();
    if (!r.ok || datos.status) throw new Error(datos.description || 'cart');
    const carrito = await (await fetch(raiz + 'cart.js')).json();
    diferido.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrito),
      detail: { items: carrito.items, source: 'persa-upsell', itemCount: 1, sections: datos.sections, didError: false },
    });
  } catch (err) {
    diferido.reject(err);
    boton.disabled = false;
    boton.textContent = '+ Sumar';
  }
});
